import React from 'react'
import { Box } from 'grid-styled'
import { Link, Tag, Text } from 'components'

const UL = Text.withComponent('ul').extend`
  list-style: none;
`

const PostsList = ({ posts }) => (
  <UL pl={3}>
    {posts && posts.map(post => (
      <li key={post.id || post.slug}>
        <Box mt={3}>
          <span role="img" aria-label="bullet">👉</span>
          <Link ml={2} to={`/writing/post/${post.slug}`}>{post.title}</Link>
          <div style={{ display: 'inline-block' }}>
            {post.tags.map(tag => <Tag key={tag.id} ml={2} tag={tag} />)}
          </div>
        </Box>
      </li>
    ))}
  </UL>)

export default PostsList



// WEBPACK FOOTER //
// /opt/build/repo/src/components/PostsList.js